import React, { Component } from 'react';

class Overview extends Component {
    state = {  }
    render() { 
        return ( 
            <p>Overview</p>
         );
    }
}
 
export default Overview;